import Clipboard from '../plugins/clipboard/clipboard';
export default {
    'clickoutside': {
        bind() {
            this.documentHandler = (e) => {
                if(this.el.contains(e.target)) {
                    return false;
                }
                if(this.expression) {
                    this.vm[this.expression]();
                }
            };
            document.addEventListener('click', this.documentHandler);
        },
        update() {

        },
        unbind() {
            document.removeEventListener('click', this.documentHandler);
        }
    },
    'copy': {
        params: ['text'],
        twoWay: true,
        bind() {
            this.clipboard = new Clipboard(this.el, {
                text:function() {
                    return this.params.text || '';
                }.bind(this)
            });
            
            this.clipboard.on('success', function(e) {
                this.set(true);
            }.bind(this));

            this.clipboard.on('error', function(e) {
                this.set(false);
            }.bind(this));

        },
        update() {

        },
        unbind() {
            this.clipboard.destroy();
        }
    }

};


// WEBPACK FOOTER //
// ./src/common/directives/directives.js